import { render } from "./escuela_corporativa_AS.vue?vue&type=template&id=d23ed810&scoped=true"
import script from "./escuela_corporativa_AS.vue?vue&type=script&lang=js"
export * from "./escuela_corporativa_AS.vue?vue&type=script&lang=js"

import "./styles/shared_AS.css?vue&type=style&index=0&id=d23ed810&scoped=true&lang=css&external"
import "./styles/escuela_corporativa_AS.css?vue&type=style&index=1&id=d23ed810&scoped=true&lang=css&external"
import "./escuela_corporativa_AS.vue?vue&type=style&index=2&id=d23ed810&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d23ed810"]])

export default __exports__